<template>
    <div>
        <div :class="sideBySide ? 'icard-container side-by-side' : 'icard-container stacked'
            " v-for="(icard_data, ind) in icard_data" :key="ind">
            <div class="container" style="background-color: white; height: 474px;">
                <div class="row" style="width: 18rem; height: 480px; background-color: white;">
                    <div class="secondarySection" v-if="icard_data.section == 'Secondary Section'">
                        <div class="ss_clgname">
                            <center>
                                <span>{{ icard_data.section }}</span>
                            </center>
                        </div>
                    </div>
                    <div class="primarySection" v-else-if="icard_data.section == 'Primary Section'">
                        <div class="ps_clgname">
                            {{ icard_data.section }}
                        </div>
                    </div>
                    <div class="priSection" v-else-if="icard_data.section == 'Pre-Primary Section'">
                        <div class="pps_clgname">
                            {{ icard_data.section }}
                        </div>
                    </div>
                    <div class="Section" v-else>
                        <div>
                            <center>
                                <span class="clgname">{{ icard_data.section }}</span>
                            </center>
                        </div>
                    </div>
                    <div class="col-10 cardArea" style="background-color: white; height: 462px;">
                        <div style="background-color: white;">
                            <img :src="common_data.logo" style="margin-left: 4px; width: 100%;" height="55"
                                alt="logo" />
                        </div>
                        <!-- ZIS changes only -->
                        <table v-if="common_data.org_id == 3">
                            <tr>
                                <td>
                                    <img width="17" height="15"
                                        src="https://vgespl-zeal.s3.ap-south-1.amazonaws.com/logo/i-card-image.jpeg" />
                                </td>
                                <td style="font-size: 0.8em; font-weight: bold; color: #023a9c; padding-bottom: 5px;">
                                    {{ common_data.heading }}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" align="center" style="font-size: 0.7em;">
                                    {{ common_data.school_address }}
                                </td>
                            </tr>
                        </table>
                        <!-- ZIS changes code end -->
                        <center v-else-if="common_data.org_id == 2">
                            <div style="line-height: 100%;">
                                <span style="font-size: 15px; font-weight: bold;" v-html="common_data.heading"> </span>
                                <br />
                                <span style="font-size: 0.6em;font-weight: bold;">{{ common_data.school_address
                                    }}</span>
                                <br />
                            </div>
                        </center>
                        <!-- SCS code end -->
                        <center v-else>
                            <span style="font-size: 0.9em; font-weight: bold;" v-html="common_data.heading"> </span>
                            <br />
                            <span style="font-size: 0.6em;font-weight: bold;">{{ common_data.school_address }}</span>
                            <br />
                        </center>

                        <div class="empimg" v-if="common_data.org_id == 2">
                            <img style="background-color: white;" class="watermark-img" :src="common_data.watermark" />
                            <center>
                                <img :src="icard_data.profile_photo_path" class="box1 profile-img"
                                    style="width: 100px; height: 106px; margin-top: 8px; border: 1px solid black;" />
                            </center>

                            <center>
                                <div class="profile-name1" align="center">
                                    <h2 style="font-size: 0.8em;">{{ icard_data.name }}</h2>
                                </div>

                                <table class="profile-content1">
                                    <tr>
                                        <th>Std: {{ icard_data.std }}</th>
                                        <th>Div: {{ icard_data.div }}</th>
                                    </tr>
                                    <tr>
                                        <th v-if="!(common_data.org_id == 2 && icard_data.section == 'Pre-Primary Section')">House: {{ icard_data.house }}</th>
                                        <th>AY: {{ icard_data.ay }}</th>
                                    </tr>
                                    <tr v-if="common_data.org_id != 2">
                                        <th>
                                            Roll No.: {{ icard_data.rollno }}
                                        </th>
                                        <th></th>
                                    </tr>
                                </table>
                                <div class="barcoded profile-barcode1">
                                    <barcode height="20" width="2" v-model="icard_data.prn"
                                        v-bind:value="icard_data.prn"> </barcode>
                                </div>
                            </center>
                        </div>
                        <!-- zis,dems stud img code -->
                        <div class="empimg" v-else>
                            <img style="background-color: white;" class="watermark-img-zis"
                                :src="common_data.watermark" />

                            <center>
                                <img :src="icard_data.profile_photo_path" class="box1 zis-img profile-img" />
                            </center>

                            <center>
                                <div class="profile-name" align="center">
                                    <h2 style="font-size: 0.9em;">{{ icard_data.name }}</h2>
                                </div>
                                <table class="profile-content">
                                    <tr>
                                        <th style="font-size: 0.7em;">Std: {{ icard_data.std }}</th>
                                        <th style="font-size: 0.7em;">Div: {{ icard_data.div }}</th>
                                    </tr>
                                    <tr>
                                        <th style="font-size: 0.7em;">
                                            House: {{ icard_data.house }}
                                        </th>
                                        <th style="font-size: 0.7em;">AY: {{ icard_data.ay }}</th>
                                    </tr>
                                    <tr v-if="common_data.org_id != 2">
                                        <th>
                                            Roll No.: {{ icard_data.rollno }}
                                        </th>
                                        <th></th>
                                    </tr>
                                </table>

                                <div class="barcoded mt-5 profile-barcode" v-if="common_data.org_id === 3">
                                    <barcode height="20" width="2" v-model="icard_data.prn"
                                        v-bind:value="icard_data.prn"> </barcode>
                                </div>
                                <div class="barcoded mt-1 profile-barcode" v-else>
                                    <barcode height="20" width="2" v-model="icard_data.prn"
                                        v-bind:value="icard_data.prn"> </barcode>
                                </div>
                            </center>
                        </div>
                        <!-- zis,dems stud img code end -->
                        <div style="line-height: 1; margin-top: 13%;" v-if="common_data.org_id == 2">
                            <img :src="common_data.sign" style="width: 40%; height: auto; margin-left: 50%;"
                                alt="logo" />
                            <strong style="margin-left: 60%;">Principal</strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container pagebreak" style="background-color: white; height: 474px;">
                <div class="row cardback" style="width: 18rem;" v-if="icard_data != ''">
                    <div style="font-size: 0.83em; margin-left: 6%; width: 100%;">
                        <strong>Address : </strong>{{ icard_data.stud_address }}
                        <br />
                        <strong> Phone : </strong> {{ icard_data.stud_contact }}<br />
                        <template v-if="common_data.org_id != 3">
                            <strong> Emergency Contact: </strong>
                            {{ icard_data.emergency_contact_number }}<br />
                        </template>
                        <strong>D.O.B.: </strong> {{ icard_data.stud_dob }}<br />
                        <span v-if="!(common_data.org_id == 2 && icard_data.section == 'Pre-Primary Section')"><strong>Blood Group: </strong>{{ icard_data.stud_blood_group }}</span>
                        <template v-if="common_data.org_id == 1">
                            <br />
                            <strong>Admission Date: </strong>{{ icard_data.stud_doj }}
                        </template>
                        <br />
                    </div>
                    <br />
                    <div style="margin-left: 10%;">
                        <strong>Rules:-</strong>
                    </div>
                    <v-row dense v-for="(i, index) in common_data.instruction" :key="index">
                        <ul class="inst">
                            <li style="padding-left: 0.2em;">{{ i.topic }}</li>
                        </ul>
                    </v-row>
                    <div style="background-color: white;">
                        <table v-if="common_data.org_id == 1">
                            <tr>
                                <td>
                                    <img style="margin-left: 5%;"
                                        src="https://vgespl-zeal.s3.ap-south-1.amazonaws.com/logo/dems_qrcode.png"
                                        class="qrcode_dems" alt="logo" />
                                </td>
                                <th>
                                    <img :src="common_data.sign" alt="logo" class="sign_dems"
                                        style="margin-right: 5%;" />
                                    <span style="margin-left: 40%;">Principal</span>
                                </th>
                            </tr>
                        </table>
                        <table v-if="common_data.org_id == 2">
                            <tr>
                                <td>
                                    <img style="margin-left: 5%;"
                                        src="https://vgespl-zeal.s3.ap-south-1.amazonaws.com/logo/scs_qrcode.png"
                                        class="qrcode_scs" alt="logo" />
                                </td>
                                <th>
                                    <img :src="common_data.sign" alt="logo" class="sign_scs" /><br />
                                    <span style="margin-left: 45%;">Principal</span>
                                </th>
                            </tr>
                        </table>
                        <table v-if="common_data.org_id == 3">
                            <tr>
                                <td>
                                    <img style="margin-left: 5%;"
                                        src="https://vgespl-zeal.s3.ap-south-1.amazonaws.com/logo/zis_qrcode.png"
                                        class="qrcode_zis" alt="logo" />
                                </td>
                                <th>
                                    <img :src="common_data.sign" alt="logo" class="sign_zis" /><br />
                                    <span style="margin-left: 45%;">Principal</span>
                                </th>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        sideBySide: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        barcode: VueBarcode,
    },
    data: () => ({
        icard_data: [],
        common_data: [],
        prn: [],
        org_id: null,
    }),
    mounted() {
        this.prn = JSON.parse(localStorage.getItem("prn"));
        this.icard_data = JSON.parse(localStorage.getItem("icard_data"));
        this.common_data = JSON.parse(localStorage.getItem("common_data"));
        this.awspath = localStorage.getItem("awspath");
        this.org_id = localStorage.getItem("EPS-org-id");
        // this.onload();
    },

    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        onload() {
            const data = {
                learners: this.prn,
                for: "specific",
                usertype: "Student",
            };
            axios
                .post("/Icard/generateIcardCommon", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.icard_data = res.data.icard_data;
                        this.common_data = res.data.common_data;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    alert("Something went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
};
</script>

<style scoped>
.icard-container.side-by-side {
    display: flex;
    flex-direction: row;
    gap: 50px;
}

.icard-container.stacked {
    display: flex;
    flex-direction: column;
}
@media (max-width: 600px) {
  .icard-container.side-by-side {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
}
.dn {
    display: none;
}

th {
    text-align: left;
    font-size: 0.7em;
    padding-right: 15px;
    padding-left: 6px;
}

.secondarySection {
    background-color: blue;
    color: white;
    height: 29rem;
    margin-top: -0.3rem;
}

.ss_clgname {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    writing-mode: vertical-lr;
    font-size: 30px;
    transform-origin: center center;
    margin-top: 5.5rem;
    margin-right: 1px;
    text-transform: uppercase;
}

.primarySection {
    background-color: red;
    color: white;
    height: 29rem;
    margin-top: -0.3rem;
}

.ps_clgname {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    writing-mode: vertical-lr;
    font-size: 30px;
    transform-origin: center center;
    margin-top: 7rem;
    margin-right: 1px;
    text-transform: uppercase;
}

.priSection {
    background-color: yellow;
    color: black;
    height: 29rem;
    margin-top: -0.3rem;
}

.pps_clgname {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    writing-mode: vertical-lr;
    font-size: 30px;
    transform-origin: center center;
    margin-top: 4.4rem;
    margin-right: 1px;
    text-transform: uppercase;
}

.Section {
    background-color: red;
    color: white;
    height: 29rem;
    margin-top: -0.3rem;
}

ul.inst {
    list-style-type: "*";
    font-weight: 500;
    font-size: 14px;
}

.clgname {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    writing-mode: vertical-lr;
    font-size: 32px;
    transform-origin: center center;
    margin-top: 8rem;
    margin-right: 1px;
}

.cardArea {
    padding: 0;
    padding-left: 6px;
}

@media print {
    .Section {
        width: 40px;
    }

    .secondarySection {
        width: 40px;
    }

    .primarySection {
        width: 40px;
    }

    .priSection {
        width: 40px;
    }

    .pagebreak {
        page-break-before: always !important;
    }

    @page {
        margin: -0.2645833mm;
        size: 53mm 86.614mm;
    }
}

.qrcode_dems {
    width: 45%;
    height: auto;
}

.qrcode_scs {
    width: 65%;
    height: auto;
    margin-top: 1rem;
}

.qrcode_zis {
    width: 80%;
    height: auto;
    margin-top: 1rem;
}

.sign_dems {
    width: 150%;
    height: auto;
    margin-top: 1rem;
    padding-right: 20px;
}

.sign_scs {
    width: 85%;
    height: auto;
    margin-top: 1rem;
    padding-left: 2rem;
}

.sign_zis {
    width: 150px;
    height: auto;
    padding-left: 1rem;
}

.zis-img {
    width: 50%;
    height: 140px;
    margin-top: 8px;
    border: 1px solid black;
}

.watermark-img {
    height: 225px;
    width: 83%;
}

.watermark-img-zis {
    height: 315px;
    width: 83%;
}

.empimg {
    position: relative;
}

.profile-img {
    position: absolute;
    top: 1%;
    right: 28%;
}

.profile-content {
    position: absolute;
    top: 52%;
    left: 8%;
}

.profile-content1 {
    position: absolute;
    top: 60%;
    left: 8%;
}

.profile-barcode {
    position: absolute;
    top: 75%;
    width: 100%;
}

.profile-barcode1 {
    position: absolute;
    top: 82%;
    width: 100%;
}

.profile-name {
    position: absolute;
    top: 47%;
    width: 100%;
}

.profile-name1 {
    position: absolute;
    top: 50%;
    width: 100%;
}
</style>
